import { H4, LI, P } from "../../../../AbstractElements";
import { BASIC_TIMELINE_LIST } from "../../../../Data/Bonus Ui/Timeline";

export const DynamicBasicTimeline = () => {
  return (
    <>
      {BASIC_TIMELINE_LIST.map(({ color, date, time, title, span }, index) => (
        <LI className="d-flex mb-3" key={index}>
          <div className={`timeline-dot-${color}`}></div>
          <div className="w-100 ms-3">
            <P className="d-flex justify-content-between mb-2">
              <span className="date-content light-background">{date}</span>
              <span>{time}</span>
            </P>
            <H4>{title}<span className="dot-notification"></span></H4>
            <P className="f-light">{span}</P>
          </div>
        </LI>
      ))}
    </>
  );
};
